import { Container, Header, MiddleContent, Footer } from "./style";

const ShippingsCards = ({ img, item, qtdSelecionada, setFrota3x4, setFrotaTruck, setFrotaCarreta, frota3x4, frotaTruck, frotaCarreta }) => {

  function handleFrotas(e, item) {

    if (item?.cargaKg === 4000) {
      setFrota3x4(e.target.value)
      console.log("ovo")
    } else if (item?.cargaKg === 12000) {
      setFrotaTruck(e.target.value)
    } else {
      setFrotaCarreta(e.target.value)
    }

  }

  return (
    <Container>
      <Header>
        <img src={`./images/${img}`} alt="shipping_icon" />
        <h3>N° de Frotas</h3>
        <input value={item?.cargaKg === 4000 ? frota3x4 : item?.cargaKg === 12000 ? frotaTruck : frotaCarreta} onChange={(e) => handleFrotas(e)} placeholder="0" />
      </Header>
      <MiddleContent>
        <h3>
          Capacidade de <span>Caixas</span>
        </h3>
        <p>
          {item?.cargaKg / 1000} <span>ton</span>
          <img src="./images/shipping_icon.svg" alt="shipping_icon" />
        </p>
      </MiddleContent>
      <MiddleContent>
        <h3>
          Custo unitário de <span>Caixas</span>
        </h3>
        <p>
          <span>R$</span> {item?.cargaCaixas} <img src="./images/cifrao.svg" alt="cifrao" />
        </p>
      </MiddleContent>
      <Footer>
      <h3>
          Carga <span>Selecionada</span>
        </h3>
        <p>
         {qtdSelecionada} <img src="./images/unit_cost.svg" alt="unit_cost" />
        </p>
      </Footer>
    </Container>
  );
};
export default ShippingsCards;
